module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category",
    class: this.cssClass
  }, [_c('div', {
    staticClass: "category__sorter"
  }), _vm._v(" "), _c('div', {
    staticClass: "category__title"
  }, [_c('editable-td', {
    attrs: {
      "initValue": this.title
    },
    on: {
      "input": _vm.titleChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "category__date"
  }, [_c('flat-pickr', {
    staticClass: "flat-picker-input",
    attrs: {
      "config": _vm.config
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-daec14c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/CatEdit.vue
// module id = 256
// module chunks = 1